import { SitesBuilderLibComponent, Fullscreen } from '@3ddv/ngx-sites-builder-lib';
import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { Subscription } from 'rxjs';
import { ToolsService } from '../services/tools.service';
import { Output, EventEmitter } from '@angular/core';

@Component({
  selector: 'app-sbeditor-tool-fullscreen',
  templateUrl: './fullscreen.component.html',
  styleUrls: ['./fullscreen.component.scss']
})
export class FullscreenComponent implements OnInit, OnDestroy {
  private subscriptions: Array<Subscription>;
  public tool: Fullscreen;
  @Output() exportTool = new EventEmitter<Fullscreen>();

  constructor(private toolsService: ToolsService) {
    this.subscriptions = [];
  }

  ngOnInit(): void {
    const tools$ = this.toolsService.getAsyncTools$().subscribe(res=>{
      if(res.fullscreen){
        this.tool = JSON.parse(JSON.stringify(res.fullscreen));
      }else{
        console.error("Fullscreen tool not found");
        return;
      }

    });
    this.subscriptions.push(tools$);
  }

  ngOnDestroy(): void {
    this.subscriptions.forEach(o=>o.unsubscribe());
  }

  onSelect($event): void{
    this.exportTool.emit(this.tool);
  }

}
